import React from "react";
import {Image} from 'react-bootstrap';

import "./ProjictCoverage.css";

import project_cover from "../../asset/images/project_cover.webp";
import project_map from "../../asset/images/project_map.webp";

// 项目覆盖
class ProjictCoverage extends React.Component {
  render() {
    return (
      <div className="project_coverage">
        <Image className="project_img" src={project_cover} />
        
        <div className="project_content">
          <div className="project_map">
            <Image className="map" src={project_map} />
          </div>
          <div className="project_word">
            <p className="project_p1">
            北京涵智博雅能源科技有限公司是一家致力于节能环保以及能源可持续发展，并不断提供创新的产品和解决方案的高技术企业。公司专注于节能减排技术的不断研发及应用,坚持持续创新和快速转化并重，为客户发掘最大的节能潜力，并提供包括技术咨询，能源系统诊断，高效能源供应，合同能源管理，能源运营托管，能源信息化，节能工程总承包等一系列综合 性能源服务。
            </p>
            <p className="project_p2">
            我们将秉承可持续发展理念，利用自身拥有的绿色环保技术优势和资深行业经验，一如既往的为我们的客户提供专业、优质的服务，同时，为保护全球环境做出自己的努力。
            </p>
          </div>
        </div>
        
      </div>
    )
  }
}

export default ProjictCoverage
